import FileSaver from "file-saver";
import dateArray from "moment-array-dates";
import moment from "moment";
import lodash from "lodash";
// import { CASHUP_DATA } from "../../../store/data/cashup";
// import { INCOME_STAFF } from "../../../store/data/incomeStaff";
// import { USERS } from "../../../store/data/user";
// import { SELECTED_BRANCH } from "../../../store/data/branch";

const formatDate = "DD/MM/YYYY";

const HEADER_DATA = [
  { label: "Voucher Sold", value: "totalVoucher" },
  { label: "Gift Sold", value: "totalNotes" },
  { label: "Total A1", value: "totalIncomeStaff" },
  { label: "Westfield GC", value: "gift" },
  { label: "EFTPOS", value: "eftpos" },
  { label: "Cash", value: "cash" },
  { label: "Bank", value: "bankTransfer" },
  { label: "Redeemed Vouchers", value: "totalVoucherRedeem" },
  { label: "Gift Taken", value: "totalRedeem" },
  { label: "Discount", value: "totalDiscount" },
  { label: "Total A2", value: "totalIncomeReceive" },
];

//rest row
const rowHeader2 = [
  "Voucher Sold",
  "Gift Sold",
  "Total A1",
  //   "Total",
  "Westfield GC",
  "EFTPOS",
  "Cash",
  "Bank",
  "Redeemed Vouchers",
  "Gift Taken",
  "Discount",
  "Total A2",
];

// export const exportSample = () => {
//   const selectedBranch = SELECTED_BRANCH;
//   const users = USERS;
//   const cashup = CASHUP_DATA?.filter((c) => c?.date !== "21/09/2023");
//   const incomeStaff = INCOME_STAFF;
//   const from = "22/9/2023";
//   const to = "23/9/2023";
//   ExportDataCSV({ selectedBranch, users, cashup, incomeStaff, from, to });
// };

export const ExportDataCSV = ({
  selectedBranch,
  users,
  cashup,
  incomeStaff,
  from,
  to,
}) => {
  if (!selectedBranch) {
    return false;
  }

  if (!users) {
    return false;
  }

  if (!cashup) {
    return false;
  }

  if (!incomeStaff) {
    return false;
  }

  if (from === null || from === undefined) {
    return false;
  }

  if (to === null || to === undefined) {
    return false;
  }

  convert_csv({ selectedBranch, users, cashup, incomeStaff, from, to });
};

const convert_csv = ({
  selectedBranch,
  users,
  cashup,
  incomeStaff,
  from,
  to,
}) => {
  const name = selectedBranch?.name;
  const branch = selectedBranch?.id;
  const rangeDate = dateArray.range(
    moment(from, formatDate),
    moment(to, formatDate),
    formatDate,
    true
  );

  //build columns;
  const columns = [name, ...rangeDate, "Total"];
  let rows = [];

  //build row
  const coop = selectedBranch?.coop || [];
  coop?.forEach((user) => {
    rows = [...rows, user];
  });

  rows = [...rows, ...rowHeader2];

  //loop data
  let data = [];
  rows?.forEach((row) => {
    let colValues = [];
    columns?.forEach((col) => {
      const value = getValues({
        row,
        col,
        incomeStaff,
        cashup,
        users,
        branch,
        name,
      });
      colValues = [...colValues, value];
    });

    const text = colValues?.join(",");
    data = [...data, text];
  });

  //export data
  const columnsString = columns.join(",") + "\n";
  const dataString = data.join("\n");

  exporData({ data: dataString, rowTableHeader: columnsString, from, to });
};

// get value row,col
const getValues = ({ row, col, incomeStaff, cashup, users, branch, name }) => {
  const con1 = rowHeader2?.includes(row);
  let result = "";

  //data income;
  if (!con1 && col === name) {
    const selectedUser = users?.find((u) => u?.id === row);
    result = `${selectedUser?.firstName} ${selectedUser?.lastName}`;
  }

  if (!con1 && col !== name && col !== "Total") {
    const incomes =
      incomeStaff?.find((i) => {
        const valids1 = i?.branch === branch || false;
        const valids2 = i?.date === col || false;
        return valids1 && valids2;
      })?.staffs || [];

    const arrIncomes = incomes?.find((i) => i?.userId === row)?.income || [];
    result = lodash.sumBy(arrIncomes, (item) => item?.value) || 0;
  }

  if (!con1 && col === "Total") {
    const incomes = incomeStaff
      ?.filter((i) => {
        const valids1 = i?.branch === branch || false;
        return valids1;
      })
      ?.map((item) => {
        const staffs = item?.staffs;
        const arrIncomes = staffs?.find((i) => i?.userId === row)?.income || [];
        const target = lodash.sumBy(arrIncomes, (item) => item?.value) || 0;

        return target;
      });
    result = lodash.sum(incomes);
  }

  //data cashup

  if (con1 && col === name) {
    return row;
  }

  if (con1 && col !== name && col !== "Total") {
    const key = HEADER_DATA?.find((item) => item?.label === row)?.value;
    const selected =
      cashup?.find((c) => c?.branch === branch && c?.date === col) || {};

    result = selected[key] || null;
    result = Math.round(result * 100) / 100;
  }

  if (con1 && col === "Total") {
    const key = HEADER_DATA?.find((item) => item?.label === row)?.value;
    const selected = cashup?.filter((c) => c?.branch === branch);
    result = lodash.sumBy(selected, key) || 0;
    // lam tron Total A1 , Total A2 of week
    if (key === "totalIncomeStaff" || key === "totalIncomeReceive") {
      // console.log("key", key);
      result = Math.round(result);
    } else {
      result = Math.round(result * 100) / 100;
    }
  }

  return result;
};

const exporData = ({ data, rowTableHeader, from, to }) => {
  // // =========================  CSV =========================
  const csvBuffer = `${rowTableHeader}${data}`;
  const fileName = `Cashup_${from}@${to}`;
  const fileType = "text/csv;charset=utf-8;";
  const fileExtension = ".csv";

  const file = new Blob([csvBuffer], { type: fileType });
  FileSaver.saveAs(file, fileName + fileExtension);
};
